export default __webpack_public_path__ + "static/media/inspectIcon.91970c80.svg";